// extracted by mini-css-extract-plugin
export var blog_image = "index-module--blog_image--Soq6x";
export var blog_post = "index-module--blog_post--OipED";
export var blog_post_wrapper = "index-module--blog_post_wrapper--1hHvy";
export var category = "index-module--category--hseW-";
export var date = "index-module--date--8pJJK";
export var date_category = "index-module--date_category--F13HE";
export var prev_next = "index-module--prev_next--PA9j2";